<template>
  <div v-if="question">
    <div class="p-3 px-5 bg-gray-toeic" v-if="SubDirection">
      <p class="text-left mb-0 text-lg max-w-3xl mx-auto"  v-html="SubDirection.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
    </div>
    <div class="p-3 max-w-xl mx-auto" v-if="question.ImageUrl">
      <img :src="question.ImageUrl" class="object-contain w-100">
    </div>
    <div class="p-3 px-5" v-if="question.Title">
      <p class="text-left mb-0 text-lg max-w-3xl mx-auto" v-html="question.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
    </div>
    <div class="p-3 px-5 bg-gray-toeic" v-if="question.Description">
      <p class="text-left mb-0 text-lg max-w-3xl mx-auto"  v-html="question.Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Part2ReplyEmail',

    data () {
      return {
        // part2Answers: ['', ''],
        // currentIndex: 0,
        // part2Timer: 600
      }
    },

    props: {
      question: {
        type: Object
      },
      index: {
        type: Number
      },
      total: {
        type: Number
      },
      answer: {
        type: Array
      },
      SubDirection: {
        type: String
      }
    },

    methods: {
      finishPart1 () {
        this.$emit('go-to-part3', this.answers)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bg-gray-toeic {
    background-color: #C0C0C0;
  }
</style>
